import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ViewChild, EventEmitter, Output, Input, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable, Subject, map, of, take } from 'rxjs';
import { MatMenuTrigger } from '@angular/material/menu';
import { SharedService } from '../../../shared/services/shared.service';
import { eTicketStatus } from '../../../shared/enums';
import { ServiceCategory } from '../../../Core classes/service-category.interface';

@Component({
  selector: 'boardFilter',
  templateUrl: './boardFilter.component.html',
  styleUrls: ['./boardFilter.component.scss','../../../../board-styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoardFilterComponent implements OnInit,OnDestroy {
  private _filterForm: FormGroup| null = null;
  private _destroy$ = new Subject();
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger| null = null;

  filtersList: any[] = []
  @Input() type: string = 'tickets'
  @Input() view: string = '';
  @Input() set filtersFromSever(filterData: any){
    if(filterData) {
      this._filterForm?.patchValue(filterData)
      this._setfiltersList()
    }
    else {
      this.restFilters()
    }
  }
  @Output() emitFillters = new EventEmitter<any>()
  maxFilterDisplayed = 3;
  eTicketStatus = eTicketStatus;
  categoriesList$: Observable<ServiceCategory[] | any> = of(null)

  constructor(
    fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private sharedService: SharedService,
  ) {
    this.getCategories()
    this._initFilters(fb)
  }

  ngOnInit() {
    this.emitFillters.emit(this._filterForm)
  }

  ngOnDestroy() {
    this._destroy$.next(null);
    this._destroy$.complete();
  }

  getCategories() {
    this.categoriesList$ = this.sharedService.getCategories().pipe(
      take(1),
      map(res => res)
    )
  }

  private _setfiltersList() {
    if(this.ticket_status.value?.length>0) {
      let index = this.filtersList.findIndex(e => e.type === 'ticket_status')
      if(index === -1) {
        this.filtersList.push({type:'ticket_status',value: this.ticket_status.value?.length });
      }
      else {
        this.filtersList[index].value = this.ticket_status.value?.length
      }
    }
    else {
      let index = this.filtersList.findIndex(e => e.type === 'ticket_status')
      if(index != -1) {
        this.filtersList.splice(index,1)
      }
    }

    if(this.messages.value) {
      let index = this.filtersList.findIndex(e => e.type === 'messages')
      if(index === -1) {
        this.filtersList.push({type:'messages',value: this.messages.value});
      }
      else {
        this.filtersList[index].value = this.messages.value
      }
    }
    else {
      let index = this.filtersList.findIndex(e => e.type === 'messages')
      if(index != -1) {
        this.filtersList.splice(index,1)
      }
    }

    if(this.categories.value?.length>0) {
      let index = this.filtersList.findIndex(e => e.type === 'categories')
      if(index === -1) {
        this.filtersList.push({type: 'categories', value: this.categories.value?.length});
      }
      else {
        this.filtersList[index].value = this.categories.value?.length
      }
    }
    else {
      let index = this.filtersList.findIndex(e => e.type === 'categories')
      if(index != -1) {
        this.filtersList.splice(index,1)
      }
    }
    this.cd.detectChanges();
  }

  private _initFilters(fb: FormBuilder) {
    this._filterForm = fb.group({
      ticket_status: fb.control([]),
      location: fb.control('all'),
      messages: fb.control(null),
      categories: fb.control([])
    });
  }

  get location(): FormControl {
    return this._filterForm?.get('location') as FormControl;
  }

  get ticket_status() {
    return this._filterForm?.get('ticket_status') as FormControl;
  }

  get messages() {
    return this._filterForm?.get('messages') as FormControl;
  }

  get categories() {
    return this._filterForm?.get('categories') as FormControl;
  }

  setValue(control: any,value: any) {
    const tempArray = this._filterForm?.controls[control].value ? this._filterForm?.controls[control].value : [];
    let index = tempArray.findIndex((e: any) => e === value)
    if(index != -1) {
      tempArray.splice(index,1)
    }
    else {
      tempArray.push(value)
    }
    this._filterForm?.controls[control].setValue(tempArray,{emitEvent: false});
   // this.trigger?.closeMenu()
    this.cd.detectChanges()
  }

  restFilters() {
    this._filterForm?.patchValue({
      ticket_status: [],
      messages: null,
      categories: []
    });
    this._setfiltersList()
    this.cd.detectChanges()
  }

  applayFilter() {
    this._filterForm?.patchValue( this._filterForm?.value)
    this.trigger?.closeMenu()
    this._setfiltersList();
    this.cd.detectChanges()
  }

  clearTag(tag: any) {
    this._filterForm?.controls[tag.type].setValue(null)
    this._setfiltersList()
    this.cd.detectChanges()
  }

  getTooltipValues(control: any) {
    let list = [];
    switch(control) {
      case 'priority' :
      case 'ticket_status' :
        let templist = this._filterForm?.controls[control].value
        templist.forEach((element: any) => {
          list.push(this.capitalizeFirstLetter(element.toLowerCase().replace("_"," ")))
        });
        break;
      default :
        list = this._filterForm?.controls[control].value
        break;
    }
    return list.join(" \n ")
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  disableCheckbox(event: any) {
    event.preventDefault()
   }
}
